export default __webpack_public_path__ + "static/media/11AW1DEC65.a6ccf636.jpg";